edit.service('EditApplicantsModalService', function($modal, ApplicationService, SliderService, SliderFactory, ApplicantModelService, GradeSetupModelService, authServiceFactory){
    var result = {};
    var item = [];
    var ind = 0;

    result.init = function(index)
    {
        if (index==undefined) {
            result.setItem({
                App_SSNI20: '',App_SSNI20Select: '', App_Last: '',App_Middle: '',App_First: '',App_Suffix: '',  App_DOB: '',
                App_Gender: 2,App_Division: '',  App_Div_Code: '',App_Tuition: '',RecomAward: 0,ConsiderAward: 0, 
                ConsiderAward_F1: 0, ConsiderAward_F2: 0,  ActAward: 0, ActAward_F1: 0, ActAward_F2: 0, Notes: '',Status: '', 
                App_Trust_Val: 0,App_Trust_Desc: '', App_SS_Inc: 0,App_Complete: 0, App_529: 0,App_Holds: 0, Res_F1: 1,Res_F2: 0,
                del: 0,xApp_First: '', xApp_Middle: '',xApp_Last: '',xApp_Suffix: '',xApp_DOB: '',xApp_Gender: '', 
                xApp_Div_Code: '',xApp_529: '', xApp_SS_Inc: '',xApp_Trust_Val: '', added: 0
            }); 
            title = 'Add Applicant';
        }
        else {
            result.setItem(ApplicationService.getAwardData()['applicants'][index]);
            title = 'Edit Applicant';
        }

        if (index == undefined) {
            result.setIndex(ApplicationService.getAwardData()['applicants'].length);
        }
        else {
            result.setIndex(index); 
        }

        grades = GradeSetupModelService.get(authServiceFactory.getAuth().schoolID);
        SliderService.pushSlider(new SliderFactory('applicationSidebar/partials/editApplicantsModal', title));
    }
    result.setItem = function(app)
    {
        item = app;
    }
    result.getItem = function()
    {
        return item;
    }
    result.setIndex = function(num)
    {
        ind = num;
    }
    result.getIndex = function()
    {
        return ind;
    }

    return result;
});

